<h2 mat-dialog-title>
  Bulk Booking Confirmation
</h2>

<mat-dialog-content class="bulk-dialog-content">
  <div
    class="overlay"
    *ngIf="isBookingInProgress">

  </div>
  <div class="summary-card">

    <div class="summary-row">
      <span>Total Slots</span>
      <strong>{{totalSlots}}</strong>
    </div>

    <div class="summary-row">
      <span>Total Amount</span>
      <strong>₹{{totalAmount}}</strong>
    </div>

  </div>


  <div class="section">

    <div class="section-title">
      Service : {{data.slots[0].productName}}
    </div>

    <div
      class="slot-row"
      *ngFor="let slot of data.slots"
      [class.unavailable]="isUnavailable(slot.uniqueId)">

      <div class="slot-venue">
        {{slot.venueName}}
      </div>

      <div class="slot-day">
        {{getShortDate(slot.uniqueId)}}
      </div>

      <div class="slot-time">
        {{slot.startTime}} - {{slot.endTime}}
      </div>

      <div class="delete-btn-container">

        <mat-icon
          class="delete-icon"
          *ngIf="isUnavailable(slot.uniqueId)"
          (click)="removeSlot(slot.uniqueId)">

          delete

        </mat-icon>

      </div>

    </div>

  </div>


  <div class="section">

    <div class="section-title">
      Customer Information
    </div>

    <div class="customer-grid">

      <div>

        <label class="fieldName">
          FIRST NAME
        </label>

        <input
          class="form-control"
          [(ngModel)]="firstName">

        <div
          class="text-danger"
          *ngIf="firstName.trim().length == 0">

          First Name is required

        </div>
      </div>

      <div>

        <label class="fieldName">
          LAST NAME
        </label>

        <input
          class="form-control"
          [(ngModel)]="lastName">
        <div
          class="text-danger"
          *ngIf="lastName.trim().length == 0">

          Last Name is required

        </div>

      </div>

      <div>

        <label class="fieldName">
          EMAIL
        </label>

        <input
          class="form-control"
          [(ngModel)]="email">
        <div
          class="text-danger"
          *ngIf="email && !isValidEmail()">

          Please enter a valid email address

        </div>

      </div>

      <div>

        <label class="fieldName">
          PHONE
        </label>

        <input
          class="form-control"
          [(ngModel)]="phone">

        <div
          class="text-danger"
          *ngIf="phone && !isValidPhone()">

          Phone number must contain exactly 10 digits

        </div>

      </div>

    </div>

  </div>


  <div class="section">

    <label class="fieldName">
      NOTES
    </label>

    <textarea
      rows="3"
      class="form-control"
      [(ngModel)]="notes">
    </textarea>

  </div>


  <div class="section">

    <div class="section-title">
      Payment
    </div>

    <div class="payment-grid">

      <div>

        <label class="fieldName">
          PAYMENT METHOD
        </label>

        <select
          class="form-control"
          [(ngModel)]="paymentMethod">

          <option value="cash">
            Cash
          </option>

          <option value="sendLink">
            Send Payment Link
          </option>

        </select>

      </div>

    </div>

  </div>


  <div
    class="payment-options"
    *ngIf="paymentMethod==='sendLink'">

    <label class="radio-row">

      <input
        type="radio"
        value="anytime"
        [(ngModel)]="paymentOption">

      Pay Anytime

    </label>


    <label class="radio-row">

      <input
        type="radio"
        value="within"
        [(ngModel)]="paymentOption">

      Pay Within Time Limit

    </label>

  </div>


  <div
    class="duration-grid"
    *ngIf="
      paymentMethod==='sendLink'
      && paymentOption==='within'
    ">

    <div>

      <label class="fieldName">
        DAYS
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInDays">

    </div>

    <div>

      <label class="fieldName">
        MINUTES
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInMin">

    </div>

  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">

  <button
    class="pop-up-btn-white"
    [disabled]="isBookingInProgress"
    (click)="cancel()">

    Cancel

  </button>

  <button
    class="pop-up-btn-blue"
    [disabled]="!canConfirmBooking() || isBookingInProgress"
    (click)="confirmBooking()">

    <mat-icon
      *ngIf="isBookingInProgress"
      class="spinner-icon">

      autorenew

    </mat-icon>

    {{isBookingInProgress ? 'Booking...' : 'Confirm Booking'}}

  </button>

</mat-dialog-actions>
<!--<div class="bulk-dialog">

  <h2 class="title">
    Bulk Booking Summary
  </h2>

  <div class="summary-card">

    <div class="summary-row">
      <span>Total Slots</span>
      <strong>{{totalSlots}}</strong>
    </div>

    <div class="summary-row">
      <span>Total Amount</span>
      <strong>₹{{totalAmount}}</strong>
    </div>

  </div>

  <div class="section-title">
    Customer Information
  </div>

  <div class="customer-grid">

    <div>
      <label class="fieldName">
        FIRST NAME
      </label>

      <input
        class="form-control"
        [(ngModel)]="firstName">
    </div>

    <div>
      <label class="fieldName">
        LAST NAME
      </label>

      <input
        class="form-control"
        [(ngModel)]="lastName">
    </div>

    <div>
      <label class="fieldName">
        EMAIL
      </label>

      <input
        class="form-control"
        [(ngModel)]="email">
    </div>

    <div>
      <label class="fieldName">
        PHONE
      </label>

      <input
        class="form-control"
        [(ngModel)]="phone">
    </div>

  </div>


  <div class="mt-4">

    <label class="fieldName">
      NOTES
    </label>

    <textarea
      rows="3"
      class="form-control"
      [(ngModel)]="notes">
    </textarea>

  </div>


  <div class="section-title mt-4">
    Payment
  </div>


  <div class="payment-grid">

    <div>

      <label class="fieldName">
        PAYMENT METHOD
      </label>

      <select
        class="form-control"
        [(ngModel)]="paymentMethod">

        <option value="cash">
          Cash
        </option>

        <option value="sendLink">
          Send Payment Link
        </option>

      </select>

    </div>

  </div>


  <div
    class="payment-options"
    *ngIf="paymentMethod === 'sendLink'">

    <div class="radio-row">

      <label>

        <input
          type="radio"
          value="anytime"
          [(ngModel)]="paymentOption">

        Pay Anytime

      </label>

    </div>


    <div class="radio-row">

      <label>

        <input
          type="radio"
          value="within"
          [(ngModel)]="paymentOption">

        Pay Within Time Limit

      </label>

    </div>

  </div>


  <div
    class="duration-grid"
    *ngIf="
      paymentMethod === 'sendLink'
      && paymentOption === 'within'
    ">

    <div>

      <label class="fieldName">
        DAYS
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInDays">

    </div>

    <div>

      <label class="fieldName">
        MINUTES
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInMin">

    </div>

  </div>


  <div class="button-panel">

    <button
      class="pop-up-btn-white"
      (click)="cancel()">

      Cancel

    </button>


    <button
      class="btn btn-primary"
      (click)="confirmBooking()">

      Confirm

    </button>

  </div>

</div>-->
<!--
<div class="container">

  <h3>
    Bulk Booking Summary
  </h3>

  <div class="summary">

    <p>
      Total Slots :
      <b>{{totalSlots}}</b>
    </p>

    <p>
      Total Amount :
      <b>₹{{totalAmount}}</b>
    </p>

  </div>


  <div class="row">

    <div class="col-md-6">

      <label class="fieldName">
        FIRST NAME
      </label>

      <input
        class="form-control"
        [(ngModel)]="firstName">

    </div>


    <div class="col-md-6">

      <label class="fieldName">
        LAST NAME
      </label>

      <input
        class="form-control"
        [(ngModel)]="lastName">

    </div>

  </div>


  <div class="row mt-3">

    <div class="col-md-6">

      <label class="fieldName">
        EMAIL
      </label>

      <input
        class="form-control"
        [(ngModel)]="email">

    </div>


    <div class="col-md-6">

      <label class="fieldName">
        PHONE
      </label>

      <input
        class="form-control"
        [(ngModel)]="phone">

    </div>

  </div>


  <div class="row mt-3">

    <div class="col-md-12">

      <label class="fieldName">
        NOTES
      </label>

      <input
        class="form-control"
        [(ngModel)]="notes">

    </div>

  </div>


  <div class="row mt-4">

    <div class="col-md-6">

      <label class="fieldName">
        PAYMENT METHOD
      </label>

      <select
        class="form-control"
        [(ngModel)]="paymentMethod">

        <option value="cash">
          Cash
        </option>

        <option value="sendLink">
          Send Payment Link
        </option>

      </select>

    </div>

  </div>


  <div
    *ngIf="paymentMethod==='sendLink'"
    class="mt-4">

    <label>

      <input
        type="radio"
        value="anytime"
        [(ngModel)]="paymentOption">

      Pay Anytime

    </label>

    <br>

    <label>

      <input
        type="radio"
        value="within"
        [(ngModel)]="paymentOption">

      Pay Within Time Limit

    </label>

  </div>


  <div
    *ngIf="
paymentMethod==='sendLink'
&& paymentOption==='within'
"
    class="row mt-3">

    <div class="col-md-3">

      <label>
        Days
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInDays">

    </div>

    <div class="col-md-3">

      <label>
        Minutes
      </label>

      <input
        class="form-control"
        [(ngModel)]="expiryInMin">

    </div>

  </div>


  <div class="mt-5">

    <button
      class="btn btn-secondary"
      (click)="cancel()">

      Cancel

    </button>

    <button
      class="btn btn-primary"
      style="margin-left:20px"
      (click)="confirmBooking()">

      Confirm Booking

    </button>

  </div>

</div>
-->
